// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IBuyCustomPackageRequest,
  TBuyCustomPackageModel,
  IMappers,
  TBuyCustomPackageResponse,
  IBuyCustomPackageResponse,
} from './types';

export const defaultConfig: TBuyCustomPackageModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'billing-service-packages-balancer',
  pathApi: '/v4/buy-custom-package/',
  requestType: 'json',
  responseType: 'json',
} as TBuyCustomPackageModel;

export function createBuyCustomPackageModel(parameters: IBuyCustomPackageRequest): TBuyCustomPackageModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IBuyCustomPackageOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IBuyCustomPackageRequest;
}

export async function fetchBuyCustomPackage<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IBuyCustomPackageOptions<TResponse200>): Promise<TBuyCustomPackageResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createBuyCustomPackageModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBuyCustomPackageResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TBuyCustomPackageResponse;
}
